export default __webpack_public_path__ + "static/media/1_10.1396b1b3.png";